/**
 * Validates if widget API response is valid and contains data
 * @param {*} widgetDataResponse - Response from GetWidgetData API
 * @returns {boolean} - True if response is a non-empty array, false otherwise
 */
export const hasValidWidgetResponse = (widgetDataResponse) => {
    if (widgetDataResponse === undefined || widgetDataResponse === null) {
        return false;
    }

    // API error responses can come as strings.
    if (typeof widgetDataResponse === "string") {
        return false;
    }

    return Array.isArray(widgetDataResponse);
};
